import { render, staticRenderFns } from "./ScanFy.vue?vue&type=template&id=72fdb773&scoped=true"
import script from "./ScanFy.vue?vue&type=script&lang=js"
export * from "./ScanFy.vue?vue&type=script&lang=js"
import style0 from "./ScanFy.vue?vue&type=style&index=0&id=72fdb773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdb773",
  null
  
)

export default component.exports